import i18n from '../../i18n';

const t = (key: string) => i18n.t(key as any) as string;

export const EDGE_COLORS = [
  { id: 'gray', label: t('canvasEntity.colorGray'), color: '#9ca3af' },
  { id: 'dark', label: t('canvasEntity.colorDark'), color: '#374151' },
  { id: 'blue', label: t('canvasEntity.colorBlue'), color: '#3b82f6' },
  { id: 'green', label: t('canvasEntity.colorGreen'), color: '#16a34a' },
  { id: 'red', label: t('canvasEntity.colorRed'), color: '#dc2626' },
  { id: 'orange', label: t('canvasEntity.colorOrange'), color: '#ea580c' },
  { id: 'purple', label: t('canvasEntity.colorPurple'), color: '#7c3aed' },
];

export const STROKE_STYLES = [
  { id: 'solid', label: t('canvasEntity.strokeSolid') },
  { id: 'longdash', label: t('canvasEntity.strokeLongDash') },
  { id: 'dashed', label: t('canvasEntity.strokeDashed') },
  { id: 'shortdash', label: t('canvasEntity.strokeShortDash') },
  { id: 'dotted', label: t('canvasEntity.strokeDotted') },
  { id: 'dashdot', label: t('canvasEntity.strokeDashDot') },
  { id: 'longdashdotdot', label: t('canvasEntity.strokeDashDotDot') },
];

export const STROKE_WIDTHS = [0.5, 1, 1.5, 2, 3, 4, 6, 8] as const;

export const STROKE_WIDTH_OPTIONS = [
  { id: '0.5', label: '0.5px' },
  { id: '1', label: '1px' },
  { id: '1.5', label: '1.5px' },
  { id: '2', label: '2px' },
  { id: '3', label: '3px' },
  { id: '4', label: '4px' },
  { id: '6', label: '6px' },
  { id: '8', label: '8px' },
];

export const ARROW_TYPES = [
  { id: 'none', label: t('canvasEntity.arrowNone') },
  { id: 'arrow', label: t('canvasEntity.arrowArrow') },
  { id: 'open-arrow', label: t('canvasEntity.arrowOpen') },
  { id: 'triangle', label: t('canvasEntity.arrowTriangle') },
  { id: 'diamond', label: t('canvasEntity.arrowDiamond') },
  { id: 'circle', label: t('canvasEntity.arrowCircle') },
  { id: 'bar', label: t('canvasEntity.arrowBar') },
  { id: 'square', label: t('canvasEntity.arrowSquare') },
];

export const BORDER_WIDTH_OPTIONS = [
  { id: 'none', label: t('canvasEntity.borderNone') },
  { id: '1', label: '1px' },
  { id: '2', label: '2px' },
  { id: '3', label: '3px' },
  { id: '4', label: '4px' },
  { id: '6', label: '6px' },
];

export const BORDER_COLOR_DEFAULTS = [
  { id: 'none', label: t('canvasEntity.noBorder'), color: '' },
  { id: 'dark', label: t('canvasEntity.colorDark'), color: '#374151' },
  { id: 'gray', label: t('canvasEntity.colorGray'), color: '#9ca3af' },
  { id: 'light', label: t('canvasEntity.colorLight'), color: '#d1d5db' },
  { id: 'blue', label: t('canvasEntity.colorBlue'), color: '#3b82f6' },
  { id: 'red', label: t('canvasEntity.colorRed'), color: '#dc2626' },
  { id: 'green', label: t('canvasEntity.colorGreen'), color: '#16a34a' },
];

export function getStrokeDasharray(style: string, width: number): string | undefined {
  switch (style) {
    case 'longdash': return `${width * 8} ${width * 3}`;
    case 'dashed': return `${width * 4} ${width * 2}`;
    case 'shortdash': return `${width * 2} ${width * 2}`;
    case 'dotted': return `${width} ${width * 2}`;
    case 'dashdot': return `${width * 4} ${width * 2} ${width} ${width * 2}`;
    case 'longdashdotdot': return `${width * 8} ${width * 2} ${width} ${width * 2} ${width} ${width * 2}`;
    default: return undefined; // solid
  }
}
